import script from "./ReceptionConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceptionConfirm.vue?vue&type=script&setup=true&lang=js"

import "./ReceptionConfirm.vue?vue&type=style&index=0&id=6828e114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6828e114"]])

export default __exports__